import { useCallback, useRef } from 'react';
import { ScheduleRequest } from '@weave/schema-gen-ts/dist/schemas/schedule/api/v2/api.pb';
import { useScheduleAppointmentInfoPanelShallowStore } from '../../../../../../stores/schedule-appointment-info-panel.store';
import { useScheduleActionsContext } from '../../ScheduleActionsContext';
import { ScheduleActionsProvider } from '../../ScheduleActionsProvider';
import { useScheduleRequestModalContextValue } from '../hooks/use-schedule-request-modal-context-value';
import { ScheduleRequestPanel } from '../ScheduleRequestModal/ScheduleRequestWrappers/ScheduleRequestPanel';
import { ScheduleRequestFormManager } from './ScheduleRequestFormManager';

const ScheduleRequestDetails = ({ onClose }: { onClose: () => void }) => {
  const {
    selectedRequest,
    setSelectedRequest: setSelectedRequestFromStore,
    resetSelectedRequest,
  } = useScheduleAppointmentInfoPanelShallowStore('selectedRequest', 'setSelectedRequest', 'resetSelectedRequest');

  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  const setSelectedRequest = useCallback(
    (request: ScheduleRequest | null) => {
      if (request === null) {
        resetSelectedRequest();
        onCloseRef.current();
      } else {
        setSelectedRequestFromStore(request, true);
      }
    },
    [setSelectedRequestFromStore, resetSelectedRequest]
  );

  const { scheduleRequestModalContextValue } = useScheduleRequestModalContextValue({
    refetchScheduleRequestList: () => {},
    selectedRequest: selectedRequest,
    setSelectedRequest: setSelectedRequest,
  });
  const scheduleActionsContextValue = useScheduleActionsContext();

  scheduleRequestModalContextValue.scheduleRequestModalProps.modalProps.show = !!selectedRequest;

  return selectedRequest ? (
    <ScheduleRequestFormManager
      wrapper={ScheduleRequestPanel}
      scheduleRequestModalContextValue={scheduleRequestModalContextValue}
      selectedScheduleRequest={selectedRequest}
      scheduleActionsContextValue={scheduleActionsContextValue}
    />
  ) : null;
};

export const ScheduleRequestDetailsPanel = ({ onClose }: { onClose: () => void }) => {
  return (
    <ScheduleActionsProvider>
      <ScheduleRequestDetails onClose={onClose} />
    </ScheduleActionsProvider>
  );
};
